var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 48,
    width: 48,
    height: 48,
    rx: 8,
    transform: "rotate(180 48 48)",
    fill: "#2F0444"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1517_7260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    fill: "#EAD40C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1517_7260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 25.8667L17.4667 32.4001C17.2223 32.6445 16.9112 32.7667 16.5334 32.7667C16.1556 32.7667 15.8445 32.6445 15.6001 32.4001C15.3556 32.1556 15.2334 31.8445 15.2334 31.4667C15.2334 31.089 15.3556 30.7778 15.6001 30.5334L22.1334 24.0001L15.6001 17.4667C15.3556 17.2223 15.2334 16.9112 15.2334 16.5334C15.2334 16.1556 15.3556 15.8445 15.6001 15.6001C15.8445 15.3556 16.1556 15.2334 16.5334 15.2334C16.9112 15.2334 17.2223 15.3556 17.4667 15.6001L24.0001 22.1334L30.5334 15.6001C30.7778 15.3556 31.089 15.2334 31.4667 15.2334C31.8445 15.2334 32.1556 15.3556 32.4001 15.6001C32.6445 15.8445 32.7667 16.1556 32.7667 16.5334C32.7667 16.9112 32.6445 17.2223 32.4001 17.4667L25.8667 24.0001L32.4001 30.5334C32.6445 30.7778 32.7667 31.089 32.7667 31.4667C32.7667 31.8445 32.6445 32.1556 32.4001 32.4001C32.1556 32.6445 31.8445 32.7667 31.4667 32.7667C31.089 32.7667 30.7778 32.6445 30.5334 32.4001L24.0001 25.8667Z",
    fill: "#EAD40C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/close-btn.d42002f03a1d139e1ecf8c4f9dbee5a8.svg";
export { ForwardRef as ReactComponent };